import { BeneficiaryType } from '@/types/customer';

export interface GetBeneficiariesFilters {
  readonly type?: BeneficiaryType;
  readonly name?: string;
  readonly fromDate?: string;
  readonly toDate?: string;
  readonly page: number;
  readonly size: number;
  readonly sort: readonly string[] | string;
}

export class GetBeneficiariesFilters {
  public static initial(): GetBeneficiariesFilters {
    return {
      page: 1,
      size: 10,
      sort: ['createdDate,desc'],
    };
  }
}
